import { Award } from '../types';

export const awards: Award[] = [
  {
    id: "champion-2024",
    title: "2024 RCL National Champion - Ditto",
    description: "",
    mediaLink: "https://www.youtube.com/watch?v=gXrXxEOxTtc"
  },
  {
    id: "finalist-2025",
    title: "2025 RCL National Finalist - Ditto",
    description: "Second place finish at the 2025 Robot Combat League National Championship",
    mediaLink: "https://www.youtube.com/watch?v=U8cH3MgBU8Q"
  }
]; 